import Vue from "vue"
import Vuex from "vuex"
import common from "./modules/common"
import auth from "./modules/auth"
import master from "./modules/master"
import order from "./modules/order"
import partner from "./modules/partner"
import role from "./modules/role"
import admin from "./modules/admin"
import armada from "./modules/armada"
import courier from "./modules/courier"
import hub from "./modules/hub"
import assignment from "./modules/assignment"
import merchant from "./modules/merchant"
import summary from "./modules/summary"
import settings from "./modules/settings"
import invoice from "./modules/invoice"
import notification from "./modules/notification"
import article from "./modules/article"
import promo from "./modules/promo"
import priceAdjustment from "./modules/priceAdjustment"
import career from "./modules/career"
import voucher from "./modules/voucher"
import banner from "./modules/banner"
import instantDelivery from "./modules/instantDelivery"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    common,
    master,
    order,
    partner,
    role,
    admin,
    armada,
    courier,
    hub,
    assignment,
    merchant,
    settings,
    summary,
    invoice,
    notification,
    article,
    promo,
    priceAdjustment,
    career,
    voucher,
    banner,
    instantDelivery
  }
})
